import React, { useCallback, useContext, useEffect, useRef } from 'react'
import ModalContext from 'contexts/ModalContext'
import SocieteNotificationModal from './SocieteNotificationModal'
import { useScreenSizeUp } from 'hooks/useScreenSize'

interface Props {
  activeSocieteNotification: App.BusinessTraveller.SocieteNotificationType | null
}

function SocieteNotificationModalTrigger({ activeSocieteNotification }: Props) {
  const isDesktop = useScreenSizeUp('tablet')
  const showModal = useContext(ModalContext)

  // Track which notification type has already triggered the modal to prevent duplicate opens
  const firedNotificationRef = useRef<App.BusinessTraveller.SocieteNotificationType | null>(null)

  const triggerModal = useCallback(() => {
    if (!activeSocieteNotification) return
    showModal(<SocieteNotificationModal notificationType={activeSocieteNotification} />)
  }, [showModal, activeSocieteNotification])

  useEffect(() => {
    if (!activeSocieteNotification) {
      firedNotificationRef.current = null
      return
    }

    // COMPLETION always shows in modal regardless of screen size
    // Other notification types only show on modal when it is mobile view
    if (activeSocieteNotification !== 'COMPLETION' && isDesktop) return

    // Only fire once per notification type — prevents duplicate modals
    if (firedNotificationRef.current === activeSocieteNotification) return

    firedNotificationRef.current = activeSocieteNotification
    triggerModal()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSocieteNotification, isDesktop])

  return null
}

export default SocieteNotificationModalTrigger
